// extracted by mini-css-extract-plugin
export default {"container":"header_container__N124p","title":"header_title__hT60b","titleGoBack":"header_titleGoBack__XE-kA","titleIcon":"header_titleIcon__ZZAoI"};